/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { JobOrderDelivery, JobOrderMethod, JobOrderStatus } from './index';
import {
  JobOrderDetailsDto,
  JobOrderListDto,
  JobOrderListItemDto,
  JobOrderListMasterInfoDto,
} from './job-order.dto';
import { JeOrderForSchedule } from '../../../builder-job-admin/jobs/resources/job-estimate-details.model';

export const JobOrderListMapper = entity<JobOrderListDto>({
  job: subentity<JobOrderListMasterInfoDto>({
    csSignedByClientDate: date(DateFormat.Date),
    csSignedByOfficeDate: date(DateFormat.Date),
    estimateAuthorizedDate: date(DateFormat.DateTime),
    scheduleStartDate: date(DateFormat.DateTime),
  }),
  jobOrders: arrayOf(subentity<JobOrderListItemDto>({
    deliveryDate: date(DateFormat.Date),
    producedDate: date(DateFormat.DateTime),
    contractReceived: date(DateFormat.Date),
    method: enumeration(JobOrderMethod),
    status: enumeration(JobOrderStatus),
    producedMethod: enumeration(JobOrderMethod),
  })),
});
export const JobOrdersForScheduleMapper = entity<JeOrderForSchedule>(
  {
    deliveryDate: date(DateFormat.Date),
    startDate: date(DateFormat.Date),
  });
export const JobOrderDetailsMapper = entity<JobOrderDetailsDto>({
  deliveryDate: date(DateFormat.Date),
  deliveryScheduleDate: date(DateFormat.Date),
  producedDate: date(DateFormat.DateTime),
  method: enumeration(JobOrderMethod),
  producedMethod: enumeration(JobOrderMethod),
  delivery: enumeration(JobOrderDelivery),
  supplierOrderBy: enumeration(JobOrderMethod),
});
